import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import { FaTrash } from 'react-icons/fa';
import { Button, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import { api_url } from '../../helpers/apiHelpers';
import { Link } from 'react-router-dom';
import { Eye } from 'lucide-react';
const Addpdf = () => {
    const [titleDialog, setTitleDialog] = useState(false);
    const [open, setOpen] = useState(false);
    const [reload, setReload] = useState(false);
    const adminId = localStorage.getItem("adminId");
    const [bookTitle, setBookTitle] = useState("");
    const [bookName, setBookName] = useState("");
    const [bookPdf, setBookPdf] = useState("");
    const [bookData, setBookData] = useState([]);
    const [bookTitleData, setBookTitleData] = useState([]);
    const [request, setRequest] = useState(false);

    const getBookTitleData = async () => {
        const response = await fetch(`${api_url}/api/admin/all-booktitle`);
        const result = await response.json();

        if (result.status === 201) {
            setBookTitleData(result.result)
        } else {
            setBookTitleData([])
        }
    }

    const getBookData = async () => {
        const response = await fetch(`${api_url}/api/admin/get-bookpdf-data`);
        const result = await response.json();
        if (result.status === 201) {
            setBookData(result.result)
        } else {
            setBookData([])
        }
    }

    useEffect(() => {
        getBookTitleData()
        getBookData();
        setReload(false)
    }, [reload])


    const storeBookTitleData = async () => {
        const response = await fetch(`${api_url}/api/admin/add-booktitle`, {
            method: "POST",
            body: JSON.stringify({
                adminId,
                bookTitle,
            }),
            headers: {
                "Content-Type": "application/json"
            }
        });
        const result = await response.json();
        if (result.status === 201) {
            setBookTitle("")
            setTitleDialog(false);
            toast.success(result.message);
            setTimeout(() => {
                setReload(true)
            }, 500)
        } else {
            toast.error(result.message)
        }
    }

    const storeBookData = async () => {
        setOpen(false);
        if (!bookTitle || !bookName || !bookPdf) {
            alert("Select all fields")
        } else {
            setRequest(true)
            const formData = new FormData();
            formData.append('adminId', adminId);
            formData.append('bookTitle', bookTitle);
            formData.append('bookName', bookName);
            formData.append('bookPdf', bookPdf);
            const response = await fetch(`${api_url}/api/admin/add-bookpdf-data`, {
                method: "POST",
                body: formData,
            });
            const result = await response.json();
            console.log(result);

            if (result.status === 201) {
                toast.success(result.message);
                setTimeout(() => {
                    setReload(true)
                }, 500)
            } else {
                toast.error(result.message)
                setRequest(false)
            }
        }
    }

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = bookData.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(bookData.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const [sortConfig, setSortConfig] = useState({ key: 'bookTitle', direction: 'asc' });

    // Sorting function
    const sortedData = React.useMemo(() => {
        let sortedBooks = [...currentItems];

        if (sortConfig !== null) {
            sortedBooks.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }

        return sortedBooks;
    }, [currentItems, sortConfig]);

    // Function to handle sorting
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };


    return (
        <div className="flex-1 overflow-auto relative z-10 p-4">
            <div className='row '>
                <div className='col-lg-9 col-10'>
                    <h2 className="mb-3 font-semibold text-2xl text-black text-center bg-[#c6e920] py-1 rounded-lg shadow-lg transition-transform duration-300">
                        Add Pdf Govt Books & GR
                    </h2>

                </div>
                <div className='col-lg-3 col-2'>
                    <Button className={'btn btn-primary  btn-sm'} onClick={() => setTitleDialog(true)}> Add Title</Button>
                    <Button className={'btn btn-primary  btn-sm ms-2'} onClick={() => setOpen(true)}> Add Book</Button>
                </div>
            </div>
            <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                className='overflow-x-auto w-full'
            >
                <table className="table table-bordered table-responsive text-left">
                    <thead>
                        <tr className="bg-gradient-to-r from-orange-100 to-orange-300">
                            <th>#</th>
                            <th onClick={() => requestSort('bookTitle')} style={{ cursor: 'pointer' }}>
                                Book Title {sortConfig.key === 'bookTitle' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                            </th>
                            <th onClick={() => requestSort('bookName')} style={{ cursor: 'pointer' }}>
                                Book Name {sortConfig.key === 'bookName' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
                            </th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sortedData.map((admin, index) => (
                                <tr key={admin.id} className="bg-white">
                                    <td>
                                        {index + 1 + (currentPage - 1) * itemsPerPage}
                                    </td>
                                    <td>{admin.bookTitle}</td>
                                    <td>{admin.bookName}</td>
                                    <td></td>
                                    {/* Action buttons or other columns */}
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </motion.div>
            <div className="flex justify-between mt-4">
                <button
                    onClick={prevPage}
                    className="px-4 py-2 bg-[#b0c22a] text-white rounded hover:bg-orange-400"
                    disabled={currentPage === 1}
                >
                    Previous
                </button>
                <span className="text-gray-600">
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    onClick={nextPage}
                    className="px-4 py-2 bg-[#b0c22a] text-white rounded hover:bg-orange-400"
                    disabled={currentPage === totalPages}
                >
                    Next
                </button>
            </div>

            <Dialog open={titleDialog} onClose={setTitleDialog} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform row overflow-hidden text-left rounded-lg max-w-4xl p-6 mb-12 mt-10 mx-auto bg-gradient-to-r from-orange-100 to-orange-300 rounded-md shadow-xl dark:bg-gray-800"
                        >
                            <div class="col-lg-12">
                                <div>
                                    <label class="text-black font-semibold text-xl dark:text-black mb-2" for="title">
                                        Book Title<span class="text-red-500 ml-1">*</span>
                                    </label>
                                    <input id="title" type="text" placeholder='Enter Book Title...' onChange={(e) => setBookTitle(e.target.value)} class="form-control" required />
                                </div>
                            </div>
                            <div className=' mt-4 gap-4 text-center'>
                                <button class="px-8 py-2.5 leading-5 text-white transition-colors duration-300 transform bg-blue-900 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600 " onClick={() => storeBookTitleData()}>Submit</button>
                                <button onClick={() => setTitleDialog(false)} class="px-8 py-2.5 ms-3 leading-5 text-white transition-colors duration-300 transform  rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600 bg-red-600">Close</button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            <Dialog open={open} onClose={setOpen} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden text-left rounded-lg max-w-4xl p-6 mb-12 mt-10 mx-auto bg-gradient-to-r from-orange-100 to-orange-300 rounded-md shadow-xl dark:bg-gray-800"
                        >
                            <div class="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
                                <div>
                                    <label class="text-black font-semibold text-xl dark:text-black " for="title">
                                        Select Book Title<span class="text-red-500 ml-1">*</span>
                                    </label>
                                    <select id="title" onChange={(e) => setBookTitle(e.target.value)} class="form-control form-select mt-2 ">
                                        <option className="font-semibold text-orange-700" value={""}>
                                            Select Title
                                        </option>
                                        {
                                            bookTitleData && bookTitleData.map((item) => (
                                                <option className="font-semibold text-orange-700" value={item.bookTitle}>
                                                    {item.bookTitle}
                                                </option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div>
                                    <label class="text-black font-semibold text-xl dark:text-black" for="name">
                                        Book Name<span class="text-red-500 ml-1">*</span>
                                    </label>
                                    <input id="name" type="text" placeholder='Enter Book Name...' onChange={(e) => setBookName(e.target.value)} class="form-control mt-2" required />
                                </div>


                            </div>
                            <div className='mt-3'>
                                <label class="text-black font-semibold text-xl dark:text-black" for="imagelinks">Add Pdf File<span class="text-red-500 ml-1">* </span></label>
                                <input id="imagelinks" type="file" placeholder='Add Book pdf...' onChange={(e) => setBookPdf(e.target.files[0])} className="form-control focus:ring" required />
                            </div>

                            <div className=' mt-4 gap-4 text-center'>
                                <button class="px-8 py-2.5 leading-5 text-white transition-colors duration-300 transform bg-blue-900 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600 " disabled={request} onClick={() => storeBookData()}>Submit</button>
                                <button onClick={() => setOpen(false)} class="px-8 py-2.5 ms-3 leading-5 text-white transition-colors duration-300 transform  rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600 bg-red-600">Close</button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default Addpdf
